import { FC, FocusEvent } from 'react'
import CDatePicker, { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'

import './style.scss'

type DatePickerProps = {
  className?: string,
  selected: Date,
  openToDate?: Date,
  dateFormat?: string,
  fullWidth?: boolean,
  tabIndex?: number,
  placeholderText?: string,
  showYearDropdown?: boolean,
  showMonthDropdown?: boolean,
  error?: boolean,
  readOnly?: boolean,
  customInput?: any,
  version?: '2' | '3' | '',
  onChange(date: Date): void
  onChangeRaw?(date: FocusEvent<HTMLInputElement>): void
}

registerLocale('es', es)

const DatePicker:FC<DatePickerProps> = ({ className = '', selected, openToDate, dateFormat = 'dd/MM/yyyy', fullWidth, tabIndex, placeholderText, showYearDropdown = false, showMonthDropdown = false, error = false, readOnly = false, customInput, version = '', onChange, onChangeRaw }) => {
  return (
    <CDatePicker
      selected={selected}
      openToDate={openToDate}
      dateFormat={dateFormat}
      placeholderText={placeholderText}
      tabIndex={tabIndex}
      showYearDropdown={showYearDropdown}
      showMonthDropdown={showMonthDropdown}
      dropdownMode="select"
      locale="es"
      customInput={customInput}
      readOnly={readOnly}
      className={`input ${fullWidth ? 'w-full' : ''} ${error ? 'input--error' : ''} ${version ? 'input--picker' + version : ''} ${className}`}
      onChange={onChange}
      onChangeRaw={onChangeRaw ? onChangeRaw : undefined}
    />
  )
}

export { DatePicker }